import React, {useEffect, useState} from "react";
import { ArrowBackIosNew } from "@mui/icons-material";
import { GridSaveAltIcon } from "@mui/x-data-grid";
import * as Yup from "yup";
import { useFormik } from "formik";
import {Button, Modal, Grid, Stack, Typography, ModalClose, Sheet, styled} from "@mui/joy";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Avatar from "@mui/joy/Avatar";

interface ModalProps {
  isOpen: boolean,
  onSubmit: (data: { file: File | null }) => void,
  onClose: () => void,
  preselectedImage: String | null,
}

const ChangeProfileImageModal: React.FC<ModalProps> = (props) => {
  const { isOpen, onClose, onSubmit, preselectedImage } = props;
  const [selectedImage, setSelectedImage] = useState<File | null>(null);

  const initialValues = {
    file: null as File | null,
  }

  const validationSchema = Yup.object().shape({
    file: Yup.mixed<File>()
      .nullable()
      .required("Debe agregar un archivo primero.")
      .test(
        "fileType",
        "Solo se permiten imágenes",
        (value) => !value || ["image/jpeg", "image/png"].includes(value.type)
      )
      .test(
        "fileSize",
        "El archivo debe ser menor de 5 MB",
        (value) => !value || value.size <= 5 * 1024 * 1024
      ),
  });


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
  });

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedImage(file);
      formik.setFieldValue("file", file);
    }
  };

  const VisuallyHiddenInput = styled('input')`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
  `;

  useEffect(() => {

  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Sheet
        variant="outlined"
        sx={{
          width: 500,
          borderRadius: 'md',
          p: 3,
          boxShadow: 'lg',
          maxHeight: 700,
        }}
      >
        <ModalClose variant="plain" sx={{ m: 1 }} />
        <Typography level="h4" component="h1" sx={{ paddingLeft: 1 }}>
          Cambiar Images de Perfil
        </Typography>
        <form className="form" onSubmit={formik.handleSubmit}>
          <Grid
            container
            marginBlock={2}
            gap={2}
            sx={{ width: '100%'}}
            justifyContent="center"
            alignItems="center"
          >
            <Button
              component="label"
              role={undefined}
              tabIndex={-1}
              variant="outlined"
              color="primary"
              startDecorator={<CloudUploadIcon />}
              sx={{width:300}}
            >
              Seleccionar Imagen
              <VisuallyHiddenInput
                type="file"
                accept="image/jpeg,image/png"
                onChange={handleImageChange} />
            </Button>

            {selectedImage ?
              <Avatar
                src={URL.createObjectURL(selectedImage)}
                sx={{width: 350, height: 350 }} />
              :
              <Avatar
                src={preselectedImage ? `${preselectedImage}` : "/static/images/avatar/1.jpg"}
                sx={{width: 350, height: 350 }} />
            }
            {formik.touched.file && formik.errors.file ? (
              <span className="Error-alert">{formik.errors.file}</span>
            ) : null}
          </Grid>
          <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{paddingRight: 1}}>
            <Button variant="outlined" endDecorator={<ArrowBackIosNew />} onClick={onClose}>Cerrar</Button>
            <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
          </Stack>
        </form>
      </Sheet>
    </Modal>
  );
};

export default ChangeProfileImageModal;
